module.exports = __webpack_public_path__ + "img/03_uk.5d410345.svg";